module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Killing Ship")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "FMH2_Front_matter_main_head_2"
  }, [_c('em', [_vm._v("Titles by Simon Beaufort from Severn House")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("THE MURDER HOUSE")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text1"
  }, [_vm._v("THE KILLING SHIP")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text1"
  }, [_c('em', [_vm._v("The Sir Geoffrey Mappestone Series")])]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("MURDER IN THE HOLY CITY")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("A HEAD FOR POISONING")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("THE BISHOP’S BROOD")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("THE KING’S SPIES")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("THE COINERS’ QUARREL")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("DEADLY INHERITANCE")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("THE BLOODSTAINED THRONE")]), _vm._v(" "), _c('p', {
    staticClass: "TSR_Teaser_text"
  }, [_vm._v("A DEAD MAN’S SECRET")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11794cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0